import * as m from 'monocle-ts'
import { Action, Reducer } from '.'
import { identity } from 'fp-ts/lib/function'
import { none, some, fold, option } from 'fp-ts/lib/Option'
import { ordString } from 'fp-ts/lib/Ord'
import { set } from 'fp-ts'
import { pipe } from 'fp-ts/lib/pipeable'
import { sequenceS } from 'fp-ts/lib/Apply'

export interface FetchState {
  fetching: Set<string>
}

export const initialFetchState: FetchState = {
  fetching: new Set<string>()
}
const fetchingLense = m.Lens.fromPath<FetchState>()(['fetching'])

export const startFetch = Symbol('start-fetch')
export const stopFetch = Symbol('stop-fetch')

const getId = (s: symbol) => (a: Action<any>) => {
  const id = (a as any)[s]
  return id !== undefined && typeof id === 'string' ? some(id) : none
}
const getStart = getId(startFetch)
const getStop = getId(stopFetch)

const insert = set.insert(ordString)
const remove = set.remove(ordString)

const onStart = (id: string) => fetchingLense.modify(prev => insert(id)(prev))
const onStop = (id: string) => fetchingLense.modify(prev => remove(id)(prev))

export const fetchReducer: Reducer<Action<any>, FetchState> = a =>
  pipe(
    sequenceS(option)({
      start: getStart(a),
      stop: getStop(a)
    }),
    fold(() => identity, ({ start, stop }) => (onStart(start), onStop(stop)))
  )



// WEBPACK FOOTER //
// ./src/framework/fetch-reducer.ts